import { CrossHostDashboard } from "./cross-host/cross-host-dashboard";
import type { EvalCase, EvalIteration, EvalSuite, EvalSuiteRun } from "./types";
import type { CaseRowSort } from "./cross-host/case-row-metrics";
import type { CellData } from "./cross-host/use-cross-host-data";

interface GroupCrossHostDashboardProps {
  suite: EvalSuite;
  cases: EvalCase[];
  runs: EvalSuiteRun[];
  allIterations: EvalIteration[];
  runGroupId: string;
  caseRowSort: CaseRowSort;
  onCaseRowSortChange: (sort: CaseRowSort) => void;
  onTestCaseClick?: (testCaseId: string) => void;
  onCellOpen?: (cell: CellData, hostId: string, caseId: string) => void;
  onDeleteTestCasesBatch?: (testCaseIds: string[]) => Promise<void>;
  /** `namedHostId` → display name for hosts with no suite attachment. */
  hostNamesById?: Map<string, string | null>;
}

export function GroupCrossHostDashboard({
  suite,
  cases,
  runs,
  allIterations,
  caseRowSort,
  onCaseRowSortChange,
  onTestCaseClick,
  onCellOpen,
  onDeleteTestCasesBatch,
  hostNamesById,
}: GroupCrossHostDashboardProps) {
  return (
    <CrossHostDashboard
      suite={suite}
      cases={cases}
      runs={runs}
      allIterations={allIterations}
      expanded
      caseRowSort={caseRowSort}
      onCaseRowSortChange={onCaseRowSortChange}
      sortControlInHeader
      onTestCaseClick={onTestCaseClick}
      onCellOpen={onCellOpen}
      onDeleteTestCasesBatch={onDeleteTestCasesBatch}
      hostNamesById={hostNamesById}
    />
  );
}
